export const DEFAULT_LOCALE_CODE = 'eng'

export const LOCALE_TO_HREFLANG = Object.freeze({
  eng: 'en',
  kin: 'rw',
  swa: 'sw',
  nya: 'ny',
})

const HREFLANG_TO_LOCALE = Object.freeze(
  Object.fromEntries(
    Object.entries(LOCALE_TO_HREFLANG).map(([localeCode, hreflang]) => [hreflang, localeCode])
  )
)

export function normalizeLocaleCode(localeCode) {
  if (!localeCode || typeof localeCode !== 'string') {
    return null
  }

  const normalizedLocaleCode = localeCode.toLowerCase()
  if (LOCALE_TO_HREFLANG[normalizedLocaleCode]) {
    return normalizedLocaleCode
  }
  return HREFLANG_TO_LOCALE[normalizedLocaleCode] || null
}

export function getHreflangForLocale(localeCode) {
  const normalizedLocaleCode = normalizeLocaleCode(localeCode)
  return normalizedLocaleCode ? LOCALE_TO_HREFLANG[normalizedLocaleCode] : null
}

export function buildLocalizedPath(path, localeCode) {
  const hreflang = getHreflangForLocale(localeCode)
  return hreflang ? `${path}?lang=${hreflang}` : path
}

/**
 * Build a localized page URL matching the active locale.
 * Mirrors the seoMixin effectiveLocale logic for use in view-level metaInfo.
 * @param {string} path - Current route path
 * @param {string|null} routeLang - Value of $route.query.lang
 * @param {string|null} storeLanguageCode - Value of $store.getters.languageCode
 * @returns {string}
 */
export function buildLocalizedPageUrl(path, routeLang, storeLanguageCode) {
  const effectiveLocale = normalizeLocaleCode(routeLang) || storeLanguageCode
  return buildLocalizedPath(path, effectiveLocale)
}
